import { styled, css } from 'next-yak'

import * as colors from '../constants/colors'
import * as glyphs from '../icons/glyphs'
import * as copy from '../styles/copy'

export const Toggler = styled.input`
  display: none;
`

export const Title = styled.label<{ $alwaysOpen?: boolean; $type?: 'boxed' | 'stroked' }>`
  align-items: center;
  cursor: ${({ $alwaysOpen }) => ($alwaysOpen ? 'default' : 'pointer')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: -19px -15px;
  padding: 14px 16px;

  ${glyphs.Icon} {
    fill-rule: evenodd;
    fill: currentColor;
    height: 18px;
    width: 18px;
  }

  ${glyphs.stroke.CaretDown} {
    display: ${({ $alwaysOpen }) => ($alwaysOpen ? 'none' : 'block')};
  }

  ${glyphs.stroke.CaretUp} {
    display: none;
  }
`

export const Content = styled.div<{ $open?: boolean; $alwaysOpen?: boolean; $animated?: boolean; $height?: number }>`
  max-height: 0;
  overflow: hidden;
  transition: 0.8s ease;

  ${({ $open, $alwaysOpen, $animated, $height }) =>
    $open || $alwaysOpen
      ? css`
          max-height: ${() => $animated ? `${$height}px` : 'max-content'};
          overflow: visible;
        `
      : ''}
`

export const ClosedContent = styled.div`
  max-height: max-content;
  overflow: hidden;
`

export const Wrapper = styled.section<{
  $type?: 'boxed' | 'stroked'
  $hideTopSeparator?: boolean
  $hideBottomSeparator?: boolean
  $alwaysOpen?: boolean
  $animated?: boolean
  $height?: number
}>`
  border: ${({ $type }) => ($type === 'boxed' ? `1px solid ${colors.PRIMARY_SAND_200}` : 'none')};
  border-radius: ${({ $type }) => ($type === 'boxed' ? '4px' : '0')};
  padding: ${({ $type }) => ($type === 'boxed' ? '16px 16px' : '0')};

  border-top: ${({ $hideTopSeparator }) => ($hideTopSeparator ? 'none' : `1px solid ${colors.PRIMARY_SAND_200}`)};
  border-bottom: ${({ $hideBottomSeparator }) =>
    $hideBottomSeparator ? 'none' : `1px solid ${colors.PRIMARY_SAND_200}`};

  ${copy.M.semiBold} {
    margin: 0;
  }

  ${({ $alwaysOpen, $animated, $height }) =>
    !$alwaysOpen &&
    css`
      ${Toggler}:checked {
    & ~ ${Title} {
      & > ${glyphs.stroke.CaretDown} {
        display: none;
      }
      & > ${glyphs.stroke.CaretUp} {
        display: block;
      }
    }

        & ~ ${Content} {
      max-height: ${() => $animated ? `${$height}px` : 'max-content'};
        }

        & ~ ${ClosedContent} {
      max-height: 0;
    }
  }`}
`
